"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iCreateWorksiteDiaryEntryComment = exports.iWorksiteDiaryEntryComment = void 0;
const t = require("io-ts");
const user_1 = require("./user");
const _iWorksiteDiaryEntryComment = t.intersection([
    t.interface({
        id: t.number,
        comment_uuid: t.string,
        entry_id: t.number,
        created_at: t.number,
        comment: t.string,
    }),
    t.partial({
        user: user_1.iAuthor,
        user_fullname: t.string // Used as backup info if user gets deleted from SokoPro
    })
]);
exports.iWorksiteDiaryEntryComment = t.clean(_iWorksiteDiaryEntryComment);
const _iCreateWorksiteDiaryEntryComment = t.interface({
    comment: t.string
});
exports.iCreateWorksiteDiaryEntryComment = t.clean(_iCreateWorksiteDiaryEntryComment);
//# sourceMappingURL=worksiteDiaryEntryComment.js.map